/**
 * v认证请求接口
 * @author 王振宇
 * @since 2022-07-24
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_AUTHENTICATIONV_PAGE_LIST: function GET_AUTHENTICATIONV_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_AUTHENTICATIONV_LIST: function GET_AUTHENTICATIONV_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/getList',
        method: 'get',
        params: data
      });
    },
    GET_AUTHENTICATIONV_INFO: function GET_AUTHENTICATIONV_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/info',
        method: 'get',
        params: data
      });
    },
    SAVE_AUTHENTICATIONV: function SAVE_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_AUTHENTICATIONV: function UPDATE_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/update',
        method: 'put',
        data: data
      });
    },
    PASS_AUTHENTICATIONV: function PASS_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/pass',
        method: 'put',
        data: data
      });
    },
    REJECT_AUTHENTICATIONV: function REJECT_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/reject',
        method: 'put',
        data: data
      });
    },
    DELETE_AUTHENTICATIONV: function DELETE_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_AUTHENTICATIONV: function DELETE_BATCH_AUTHENTICATIONV() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/authenticationV/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});